<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems"/>

    <heading-one class="-margin-md">トピックス</heading-one>

    <list-group v-if="topicList.length > 0" class="-link -visited">
      <list-item v-for="(topic, index) in topicList" :key="index" class="-link" :href="topic.url">
        <span class="date -db">{{topic.display_date}}</span>
        {{topic.title}}
      </list-item>
    </list-group>

    <btngroup-single class="-margin-lg" v-if="readMoreFlag">
      <btn-main class="-normal" @click.prevent="showMore">
        もっと見る
      </btn-main>
    </btngroup-single>

  </div><!-- container -->
</template>

<script>
import { getTopicsList } from '../utils/CmsHelper'
import HeadingOne from '../components/heading/HeadingOne'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  name: 'Nw-001',
  metaInfo: {
    title: 'トピックス',
    meta: [
      {name: 'description', content: 'au PAY スマートローンのTOPICSの一覧ページになります。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お知らせ,ニュース,トピックス,重要なお知らせ,緊急のお知らせ'}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'トピックス',
        active: true
      }],
      isDisabled: false,
      readMoreFlag: false,
      topicList: []
    }
  },
  mounted () {
    this.getTopics('1')
  },
  methods: {
    getTopics (first_view_flag = '1') {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        getTopicsList(first_view_flag).then(res => {
          this.topicList = this.topicList.concat(res.topics || [])
          this.readMoreFlag = res.read_more_flag
        }).catch(error => {
          this.goToErrorPage(error)
        }).finally(() => {
          this.isDisabled = false
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    showMore () {
      this.getTopics('0')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .heading-icon {
    text-align: left !important;
    justify-content: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Nw001.vue